<div class="panel">
    <div class="panel-body">
        <h6 class="bxt-table-title">
            {{ 'catalogues.catalogues' | translate }} <span *ngIf="rows && rows.length">({{ rows.length }})</span>
        </h6>
        <div class="header">
            <div class="new">
                <button class="btn-bx-primary" (click)="addPriceList()">Create New</button>
            </div>
        </div>
        <div class="table-responsive">
            <div class="table-wrapper" #tableWrapper>
                <ngx-datatable
                    [ngStyle]="{ height: tableHeight }"
                    #myTable
                    class="material bxt-table contact-catalogue-table"
                    [rowHeight]="40"
                    [rows]="rows"
                    [columnMode]="'force'"
                    [headerHeight]="50"
                    [loadingIndicator]="isLoading"
                    [externalSorting]="true"
                    (sort)="onSort($event)"
                    [sorts]="[{ prop: tableConfig.sort.columnName, dir: tableConfig.sort.direction.toLowerCase() }]"
                    [footerHeight]="50"
                    [scrollbarV]="true"
                    [scrollbarH]="layoutService.isMobile()"
                    [virtualization]="false">
                    <ngx-datatable-column name="Description" prop="description">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a [routerLink]="['/price', 'price-view', row.iD_Catalogue, 'details']">{{ row.description }}</a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Created" prop="dateCreated">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.dateCreated | date: 'mediumDate' }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Updated" prop="dateModified">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.dateModified | date: 'mediumDate' }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a
                                [attr.disabled]="row.catalogueType === 1 ? true : null"
                                (click)="updateCatalogue(row)"
                                class="btn btn-sm btn-primary"
                                title="Update"
                                ><i class="ti-arrow-circle-up"></i
                            ></a>
                            <a (click)="importFromExcel(row)" class="btn btn-sm btn-default" title="Import (from Excel file)"
                                ><i class="ti-upload"></i
                            ></a>
                            <a
                                *ngIf="!row.IsForeignOwned"
                                (click)="exportToExcel(row)"
                                class="btn btn-sm btn-default"
                                title="Export (to Excel file)"
                                ><i class="ti-download"></i
                            ></a>
                            <a
                                class="btn btn-sm btn-danger"
                                *ngIf="!row.IsForeignOwned"
                                (click)="deleteCatalogue(row.iD_Catalogue)"
                                title="Delete"
                                ><i class="ti-trash"></i
                            ></a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-footer></ngx-datatable-footer>
                </ngx-datatable>
            </div>
        </div>
    </div>
</div>
